export default {
  "adjustAppConfig.thead.id": "ID",
  "adjustAppConfig.thead.no": "#序号",
  "adjustAppConfig.thead.appToken": "AppToken",
  "adjustAppConfig.thead.register": "注册事件",
  "adjustAppConfig.thead.firstDeposit": "首充事件",
  "adjustAppConfig.thead.deposit": "充值事件",
  "adjustAppConfig.thead.operator": "操作人",
  "adjustAppConfig.thead.action": "操作",
  "adjustAppConfig.action.create": "新增",
  "adjustAppConfig.action.edit": "编辑",
  "adjustAppConfig.action.delete": "删除",
  "adjustAppConfig.copy.success": "复制成功!!!",
  "freeSpinConfig.confirm.delete.title": "删除",
  "freeSpinConfig.confirm.delete.content": "确定要删除这条记录吗？",
  "freeSpinConfig.confirm.ok": "确认",
  "freeSpinConfig.confirm.cancel": "取消",
};
